<template>
  <div>
    <px-view-module-header module-name="Marketplace" :breadcrumbs="breadcrumbs"/>
    <v-card class="rounded-card card-shadow mt-8">
      <v-card-text class="text--primary text-center">
        <div v-if="loading">
          <px-circular-loading/>
        </div>
        <div v-if="!loading && sucesso">
          <span class="title font-weight-bold">
          <v-icon large color="success">mdi-check-circle</v-icon>
          Conta vinculada com sucesso!
        </span>
          <div class="mt-3">
            <v-btn text class="normal-btn-text rounded-tag-small"
                   link to="/marketplace/configuracoes-frete">
              Voltar para configurações
            </v-btn>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import FornecedorService from '@/api/fornecedor-service';
import ConfiguracaoFreteService from './configuracao-frete-service';

export default {
  data() {
    return {
      code: this.$route.query.code,
      loading: false,
      sucesso: false,
      breadcrumbs: [
        { text: 'Marketplace' },
        { text: 'Configurações de frete' },
      ],
    };
  },
  methods: {
    async registerLogin() {
      this.loading = true;
      this.fornecedor = (await FornecedorService.getDefault()).data;
      console.log(this.fornecedor);
      ConfiguracaoFreteService.vincularContaMelhorEnvio(this.fornecedor.id, this.code)
        .then(() => {
          this.sucesso = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    if (!this.code) {
      return;
    }
    this.registerLogin();
  },
};
</script>
